module.exports = __webpack_public_path__ + "static/media/hospital-week-hero.e762571d.jpg";